import StatusRenderer from 'components/common/StatusRenderer';
import { CreativeStatusBadge } from 'consts/creative';

type InventoryStatusRendererProps = {
  value: string;
  data: {
    fileId?: string;
    fileName?: string;
  };
  statuses: CreativeStatusBadge[];
  onClick: (fileId: string, fileName: string, code?: string) => void;
  isAssetTemplateV2Enabled?: boolean;
};

const InventoryStatusRenderer = ({
  value,
  data = {},
  statuses,
  onClick,
  isAssetTemplateV2Enabled = false,
}: InventoryStatusRendererProps): React.ReactElement => {
  const { fileId = '', fileName = '' } = data;
  const { code } = statuses.find((status) => status.code === value) ?? {};

  if (isAssetTemplateV2Enabled) {
    return <StatusRenderer value={value} statuses={statuses} isTruncatedLabel={false} />;
  }

  return (
    <button type="button" data-test-id="status-renderer-button" onClick={() => onClick(fileId, fileName, code)}>
      <StatusRenderer value={value} statuses={statuses} isTruncatedLabel={false} />
    </button>
  );
};

export default InventoryStatusRenderer;
